









































































































































































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LogisticsNetwork } from '@/dto/';
import SVGCircle from './Shapes/Circle.vue';
import SVGPolygon from './Shapes/Polygon.vue';
import SVGRect from './Shapes/Rect.vue';
import SVGLine from './Shapes/Line.vue';
import MeasureDiv from './Shapes/MeasureDiv.vue';
import { guid } from '@/core/helpers/utils';
import { Formatters } from '@/core/components/networkViewer/formatters';
import _ from 'lodash';
import {
    MapObject,
    ChannelGroup,
    SelectedChannel,
    FakeMapObject,
    IncomingHandle,
    OutgoingHandle,
} from './types';

@Component({
    components: {
        SVGCircle,
        SVGPolygon,
        SVGRect,
        SVGLine,
        MeasureDiv,
    },
})
export default class SVGTemplate extends Vue {
    @Prop({ type: Array, required: false }) public mapObjects!: MapObject[];
    @Prop({ type: Array, required: false }) public channels!: ChannelGroup[];
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: true }) public settings!: any;
    @Prop({ type: Object, required: true }) public model!: any;
    @Prop({ type: Object, required: false })
    public fakeMapObject!: FakeMapObject;
    @Prop({ type: Object, required: false })
    public incomingHandle!: IncomingHandle;
    @Prop({ type: Object, required: false })
    public outgoingHandle!: OutgoingHandle;
    @Prop({ type: Object, required: false })
    public selectedChannel!: SelectedChannel;
    @Prop({ type: Boolean, required: false }) public visibleChannel!: boolean;

    public viewport: SVGGElement | null = null;
    public root: SVGElement | null = null;
    public measureDiv: MeasureDiv | null = null;
    public idCounter: number = 0;

    public mounted() {
        const viewportName = 'network-viewport';
        const rootName = 'network-root';
        const measureDiv = 'measureDiv';
        this.viewport = this.$refs[viewportName] as SVGGElement;
        this.root = this.$refs[rootName] as SVGElement;
        this.measureDiv = this.$refs[measureDiv] as MeasureDiv;
    }

    public selectMapObject(item: any, value: any) {
        this.$emit('selectMapObject', item, value);
    }

    public selectChannel(
        item: any,
        value1: any,
        value2: any,
        value3: any,
        event: any
    ) {
        this.$emit('selectChannel', item, value1, value2, value3, event);
    }

    public calculateRectY(item: any): number {
        if (item === null || item === undefined) {
            return 0;
        }

        let result = this.addHeight(0, item.name, 'panel item-name') ?? 0;
        result = Formatters.prototype.div(result, 2);
        result = Formatters.prototype.add(result, 8);
        return Formatters.prototype.invert(result);
    }

    private svgTranslate(mapObject: any) {
        return 'translate(' + mapObject.x + ' ' + mapObject.y + ')';
    }

    private addHeight(value: number, text: string, styles: string) {
        const height = this.measureDiv?.addHeight(value, text, styles);

        return height! + 4;
    }

    private get getId() {
        const id = guid() + this.idCounter + _.uniqueId('id_');
        this.idCounter = this.idCounter + 1;
        return _.uniqueId('id_') + this.measureDiv?.getId();
    }

    private addWidth(value: number, text: string, styles: string) {
        return this.measureDiv?.addWidth(value, text, styles);
    }

    private showRect(item: MapObject) {
        if (
            _.isEqual(this.network.state.selectedMapObject, item) ||
            this.settings.showNetworkLabels ||
            this.network.state.mapIsMoving
        ) {
            return true;
        } else {
            return false;
        }
    }

    private polygons(
        item: any = null,
        showPolygon: number,
        onlyLast: boolean = false,
        hideEmpty: boolean = false
    ): any {
        let polygons: any;

        switch (showPolygon) {
            case 1:
                polygons = Formatters.prototype.svg_channel_polygons(
                    item,
                    item.point1.mapObject,
                    item.point2.mapObject,
                    item.point1.flow,
                    item.point2.flow,
                    this.network.state.general.maxFlow,
                    this.network.preferences.channel.minDisplayCapacityWidth,
                    this.network.preferences.channel.maxDisplayCapacityWidth,
                    4,
                    onlyLast,
                    hideEmpty
                );
                break;
            case 2:
                polygons = Formatters.prototype.svg_channel_polygons(
                    item,
                    item.point1.mapObject,
                    item.point2.mapObject,
                    item.point1.flow,
                    item.point2.flow,
                    this.network.state.general.maxFlow,
                    this.network.preferences.channel.minDisplayFlowWidth,
                    this.network.preferences.channel.maxDisplayFlowWidth,
                    12,
                    onlyLast,
                    hideEmpty
                );
                break;
            default:
                polygons = Formatters.prototype.svg_channel_polygons(
                    this.selectedChannel,
                    this.selectedChannel.point.mapObject,
                    this.selectedChannel.backwardPoint.mapObject,
                    this.selectedChannel.point.flow ?? 0,
                    this.selectedChannel.backwardPoint.flow ?? 0,
                    this.network.state.general.maxFlow,
                    this.network.preferences.channel.minDisplayFlowWidth,
                    this.network.preferences.channel.maxDisplayFlowWidth,
                    12,
                    onlyLast,
                    hideEmpty
                );
                break;
        }

        return polygons;
    }
}
